<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Καλώς Ηρθες !</h5>
                  <p>Συνδέσου για να συνεχίσεις</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <!-- <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link> -->
            </div>

            <div v-if="errors">
              <b-alert show variant="danger">{{
                errors["non_field_errors"][0]
              }}</b-alert>
            </div>

            <b-form class="p-2" @submit.prevent="login">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Username or Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="text"
                  placeholder="Enter Username or Email"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                ></b-form-input>
              </b-form-group>

              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Σύνδεση</b-button
                >
              </div>

              <!-- <div class="mt-4 text-center">
                <router-link to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> Forgot your password?
                </router-link>
              </div> -->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <!-- <p>
            Don't have an account ?
            <router-link to="/register" class="fw-medium text-primary"
              >Signup now</router-link
            >
          </p> -->
          <p>
            © {{ new Date().getFullYear() }}
            <a href="https://www.proset.gr/" target="_blank">Proset</a>. Crafted
            with <i class="mdi mdi-heart text-danger"></i> by ProsetTeam
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

export default {
  page: {
    title: "Είσοδος",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },

  data() {
    return {
      email: "",
      username: "",
      password: "",
      errors: "",
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  watch: {
    username() {
      this.errors = "";
    },
    password() {
      this.errors = "";
    },
  },

  methods: {
    login() {
      this.$store
        .dispatch("auth/logIn", {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$store.dispatch("utils/fetchIndystryData");

          this.$store.dispatch("utils/fetchRolesCount");
          this.$store.dispatch("utils/fetchDepartmentOptions");
          this.$store.dispatch("utils/fetchDepartments");
          this.$store.dispatch("utils/getDevices");
          this.$store.dispatch("utils/fetchEmploymentRelationship");
          this.$store.dispatch("utils/fetchPeopleOptionFields", {
            peopleFilter: { department: "" },
          });
          this.$store.dispatch("utils/fetchRoleChoices");
          this.$store.dispatch("people/fetchHomeBanner");
          this.$store.dispatch("auth/currentUser");
          this.$store.dispatch("utils/getSignatures");
          this.$store.dispatch("utils/fetchVersion");

          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "home",
            }
          );
        })
        .catch((error) => {
          this.errors = error.response.data;
        });
    },
  },
};
</script>
